module.exports = __webpack_public_path__ + "img/contracts.c6702138.png";